import React from 'react';
import { logClientEvent } from '../Lib/clientEventLog';

const ERROR_MESSAGE = '\u9875\u9762\u6682\u65f6\u65e0\u6cd5\u663e\u793a\u3002\u8bf7\u91cd\u65b0\u626b\u63cf\u4e8c\u7ef4\u7801\u6216\u91cd\u65b0\u52a0\u8f7d\u3002';
const RELOAD_LABEL = '\u91cd\u65b0\u52a0\u8f7d';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        logClientEvent('react_error_boundary', {
            message: error && error.message,
            stack: error && error.stack,
            componentStack: info && info.componentStack,
        });
    }

    render() {
        if (!this.state.hasError) return this.props.children;

        return (
            <div style={{ padding: 24, fontFamily: 'sans-serif', lineHeight: 1.5 }}>
                <div style={{ fontSize: 16, marginBottom: 12 }}>{ERROR_MESSAGE}</div>
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    style={{ padding: '10px 16px', border: 0, background: '#1f4fbf', color: '#fff', borderRadius: 4 }}
                >
                    {RELOAD_LABEL}
                </button>
            </div>
        );
    }
}

export default ErrorBoundary;